import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/logo.png'
import _imports_1 from '@/assets/img/ar.svg'
import _imports_2 from '@/assets/img/us.svg'


const _hoisted_1 = { class: "min-h-screen flex flex-col justify-between" }
const _hoisted_2 = { class: "flex flex-col flex-1 items-center justify-center mt-6" }
const _hoisted_3 = { class: "bg-white rounded-xl shadow-md p-3 w-11/12 md:w-8/12 lg:w-5/12" }
const _hoisted_4 = { class: "w-full flex flex-col my-4 text-center" }
const _hoisted_5 = { class: "text-xl font-weight-bolder text-gray-800" }
const _hoisted_6 = { class: "text-xl font-weight-bolder text-gray-500" }
const _hoisted_7 = { class: "text-xl font-weight-bolder text-gray-500 mt-3" }
const _hoisted_8 = { class: "text-base font-weight-bolder text-gray-400" }
const _hoisted_9 = {
  key: 0,
  class: "w-full flex flex-col my-4 text-center"
}
const _hoisted_10 = { class: "text-2xl font-weight-bolder text-gray-800 uppercase" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "w-full flex flex-col my-4 text-center pt-3 pb-4 bg-gray-200 rounded-lg" }
const _hoisted_13 = { class: "text-xl font-semibold text-gray-800 uppercase" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "flex flex-wrap -mx-2 space-y-2 md:space-y-0 my-3" }
const _hoisted_16 = { class: "w-full px-2" }
const _hoisted_17 = { class: "block mb-1 text-sm text-gray-600" }
const _hoisted_18 = { class: "text-sm text-red-500 p-error" }
const _hoisted_19 = { class: "flex flex-wrap -mx-2 space-y-2 md:space-y-0 pt-6 px-2" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "w-full border border-gray-300 rounded-lg shadow-xs p-5 space-y-0 md:space-y-2" }
const _hoisted_23 = { class: "flex flex-wrap -mx-2 space-y-2 md:space-y-0" }
const _hoisted_24 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_25 = { class: "block mb-1 text-sm text-gray-600" }
const _hoisted_26 = { class: "text-xl font-bold" }
const _hoisted_27 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_28 = { class: "block mb-1 text-sm text-gray-600" }
const _hoisted_29 = { class: "text-xl font-bold" }
const _hoisted_30 = { class: "flex flex-wrap -mx-2 space-y-2 md:space-y-0" }
const _hoisted_31 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_32 = { class: "block mb-1 text-sm text-gray-600" }
const _hoisted_33 = { class: "text-xl font-bold" }
const _hoisted_34 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_35 = { class: "block mb-1 text-sm text-gray-600" }
const _hoisted_36 = { class: "text-xl font-bold" }
const _hoisted_37 = { class: "flex flex-wrap -mx-2 space-y-2 md:space-y-0" }
const _hoisted_38 = { class: "w-full px-2" }
const _hoisted_39 = { class: "block mb-1 text-sm text-gray-600" }
const _hoisted_40 = { class: "text-xl font-bold" }
const _hoisted_41 = {
  key: 0,
  class: "flex flex-wrap -mx-2 space-y-2 md:space-y-0 my-4"
}
const _hoisted_42 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_43 = { class: "block mb-1 text-sm text-gray-600" }
const _hoisted_44 = { class: "text-sm text-red-500 p-error" }
const _hoisted_45 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_46 = { class: "block mb-1 text-sm text-gray-600" }
const _hoisted_47 = { class: "text-sm text-red-500 p-error" }
const _hoisted_48 = {
  key: 1,
  class: "flex flex-wrap -mx-2 space-y-2 md:space-y-0 my-4"
}
const _hoisted_49 = { class: "w-full px-2" }
const _hoisted_50 = { class: "block mb-1 text-sm text-gray-600" }
const _hoisted_51 = { class: "text-sm text-red-500 p-error" }
const _hoisted_52 = { class: "flex flex-wrap -mx-2 space-y-2 md:space-y-0 pt-6 px-2" }
const _hoisted_53 = ["disabled"]
const _hoisted_54 = { class: "flex items-center gap-3 md:gap-4 my-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_FullScreenLoader = _resolveComponent("FullScreenLoader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "flex justify-center items-center" }, [
            _createElementVNode("a", {
              class: "text-center",
              href: "/"
            }, [
              _createElementVNode("img", {
                src: _imports_0,
                class: "p-2.5 w-24 h-auto"
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.configuracionMeeting?.evento?.descripcion), 1),
            _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.configuracionMeeting?.descripcion), 1),
            _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t('label.titulo.registro')), 1),
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('label.complete.formulario')), 1)
          ]),
          (!_ctx.isSubmitting && !_ctx.empresa)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("h3", _hoisted_10, _toDisplayString(_ctx.errorMessage), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.empresa)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("h3", _hoisted_13, _toDisplayString(_ctx.empresa.razonSocial), 1)
                ]),
                (!_ctx.acreditado)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('label.dni')), 1),
                          _createVNode(_component_Field, {
                            name: "dni",
                            modelValue: _ctx.formData.dni,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.dni) = $event))
                          }, {
                            default: _withCtx(({ field, errors }) => [
                              _createVNode(_component_InputText, _mergeProps(field, {
                                type: "text",
                                class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                                placeholder: _ctx.$t('label.dni')
                              }), null, 16, ["placeholder", "class"]),
                              _createElementVNode("span", _hoisted_18, [
                                _createVNode(_component_ErrorMessage, { name: "dni" })
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("button", {
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.validarDni && _ctx.validarDni(...args))),
                          class: "w-full text-sm font-bold text-white py-3 bg-gradient-to-r from-[#424c42] to-[#bbc1a9] shadow-md rounded-xl transform transition-transform duration-200 hover:scale-[101%] active:scale-95",
                          disabled: _ctx.isSubmitting
                        }, [
                          _createVNode(_component_font_awesome_icon, { icon: ['far', 'fa-id-card'] }),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.continuar')), 1)
                        ], 8, _hoisted_20)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.acreditado)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('label.nombre')), 1),
                            _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.acreditado.nombre), 1)
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('label.apellido')), 1),
                            _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.acreditado.apellido), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t('label.cargo')), 1),
                            _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.acreditado.cargo), 1)
                          ]),
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.$t('label.telefono')), 1),
                            _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.acreditado.telefono), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.$t('label.mail')), 1),
                            _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.acreditado.mail), 1)
                          ])
                        ])
                      ]),
                      (!_ctx.acreditado.tienePassword)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                            _createElementVNode("div", _hoisted_42, [
                              _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.$t('label.contrasenia')), 1),
                              _createVNode(_component_Field, {
                                name: "password",
                                modelValue: _ctx.formData.password,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.password) = $event))
                              }, {
                                default: _withCtx(({ field, errors }) => [
                                  _createVNode(_component_InputText, _mergeProps(field, {
                                    type: "password",
                                    class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                                    placeholder: _ctx.$t('label.contrasenia')
                                  }), null, 16, ["placeholder", "class"]),
                                  _createElementVNode("span", _hoisted_44, [
                                    _createVNode(_component_ErrorMessage, { name: "password" })
                                  ])
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_45, [
                              _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.$t('label.contrasenia.repetida')), 1),
                              _createVNode(_component_Field, {
                                name: "passwordRepetida",
                                modelValue: _ctx.formData.passwordRepetida,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.passwordRepetida) = $event))
                              }, {
                                default: _withCtx(({ field, errors }) => [
                                  _createVNode(_component_InputText, _mergeProps(field, {
                                    type: "password",
                                    class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                                    placeholder: _ctx.$t('label.contrasenia.repetida')
                                  }), null, 16, ["placeholder", "class"]),
                                  _createElementVNode("span", _hoisted_47, [
                                    _createVNode(_component_ErrorMessage, { name: "passwordRepetida" })
                                  ])
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.acreditado.tienePassword)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.$t('label.contrasenia')), 1),
                              _createVNode(_component_Field, {
                                name: "password",
                                modelValue: _ctx.formData.password,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.password) = $event))
                              }, {
                                default: _withCtx(({ field, errors }) => [
                                  _createVNode(_component_InputText, _mergeProps(field, {
                                    type: "password",
                                    class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                                    placeholder: _ctx.$t('label.contrasenia')
                                  }), null, 16, ["placeholder", "class"]),
                                  _createElementVNode("span", _hoisted_51, [
                                    _createVNode(_component_ErrorMessage, { name: "password" })
                                  ])
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("button", {
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.registrar && _ctx.registrar(...args))),
                          class: "w-full text-sm font-bold text-white py-3 bg-gradient-to-r from-[#424c42] to-[#bbc1a9] shadow-md rounded-xl transform transition-transform duration-200 hover:scale-[101%] active:scale-95",
                          disabled: _ctx.isSubmitting
                        }, [
                          _createVNode(_component_font_awesome_icon, { icon: ['fas', 'fa-check-double'] }),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.aceptar')), 1)
                        ], 8, _hoisted_53)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("button", {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeLanguage('es'))),
            class: "transition hover:scale-125 cursor-pointer"
          }, _cache[9] || (_cache[9] = [
            _createElementVNode("img", {
              src: _imports_1,
              class: "h-6 md:h-8"
            }, null, -1)
          ])),
          _createElementVNode("button", {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changeLanguage('en'))),
            class: "transition hover:scale-125 cursor-pointer"
          }, _cache[10] || (_cache[10] = [
            _createElementVNode("img", {
              src: _imports_2,
              class: "h-6 md:h-8"
            }, null, -1)
          ]))
        ])
      ])
    ]),
    _createVNode(_component_FullScreenLoader, { visible: _ctx.isSubmitting }, null, 8, ["visible"])
  ], 64))
}